import {HarcTuruEntity} from "@/entity/HarcTuruEntity";

export class HarcDonemiEntity {
    baslangic_tarihi!:Date;
    id!:number;
    harclar!:HarcTuruEntity[];
    text?:string
}
